import React, { FC } from 'react'
import { MenuItemType } from 'types/editorSettings'
import { EDITOR_MAIN_SETTINGS } from 'config/constants/mainView'
import { RenderSettingsPanel } from './settings/RenderSettings'
import { BehaviourSettingsPanel } from './settings/BehaviourSettings'
import { ViewSettingsPanel } from './settings/ViewSettings'

interface IProps {
  activeMenuItem: MenuItemType
}

export const EditorSettingsParams:FC<IProps> = ({ activeMenuItem }) => {
  switch (activeMenuItem) {
    case EDITOR_MAIN_SETTINGS.RENDER:
      return <RenderSettingsPanel />
    case EDITOR_MAIN_SETTINGS.BEHAVIOUR:
      return <BehaviourSettingsPanel />
    case EDITOR_MAIN_SETTINGS.VIEW:
      return <ViewSettingsPanel />
    default:
      return <div />
  }
}
